import { ChangeDetectionStrategy, Component, computed, effect, input, signal, viewChild } from '@angular/core';
import { YouTubePlayer } from '@angular/youtube-player';
import { EffyButtonSize, EffyButtonStyle } from '@effy-tech/angular-common/button';
import { IFieldMediaImage } from '../../interfaces/field-media-image';
import { SafeResourceUrlPipe } from '../../pipes/safe-resource-url/safe-resource-url.pipe';
import { LegendComponent } from '../legend/legend.component';
import { VideoPlayBackgroundComponent } from '../video-play-background/video-play-background.component';

@Component({
  selector: 'nscf-youtube-wrapper',
  imports: [VideoPlayBackgroundComponent, SafeResourceUrlPipe, YouTubePlayer, LegendComponent],
  templateUrl: './youtube-wrapper.component.html',
  styleUrl: './youtube-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubeWrapperComponent {
  readonly cover = input<IFieldMediaImage | null>(null);
  readonly videoId = input<string | null>(null);
  readonly legend = input<string | null>(null);

  protected readonly youtubePlayer = viewChild<YouTubePlayer>('youtubePlayer');

  protected readonly loadedMedias = signal(false);
  protected readonly shouldDisplayYoutubePlayer = computed(() => !!this.videoId() && (this.loadedMedias() || !this.cover()));
  protected readonly autoplay = effect(() => this.shouldDisplayYoutubePlayer() && this.cover() && this.youtubePlayer()?.playVideo());
  protected readonly buttonSize = EffyButtonSize;
  protected readonly buttonStyle = EffyButtonStyle;

  loadVideo(): void {
    this.loadedMedias.set(true);
  }
}
